import React from "react";
import "./button.scss";
import plusImage from "../../assets/images/button/plus.svg";
import purplePlus from "assets/images/button/purplePlus.svg";
import uploadArrow from "assets/images/button/upload.svg";

const Button = ({
  buttonId,
  children,
  disabled,
  loading = false,
  title = "",
  showImage = false,
  type = "",
  width,
  height,
  onClick = () => {},
  btnType = "submit",
  showPurplePlus = false,
  showUpArrow = false,
  padding = "14px 18px",
}) => {
  return (
    <button
      data-testid={buttonId}
      disabled={disabled || loading}
      style={{
        width: width || undefined,
        height: height || undefined,
        padding: padding || undefined
      }}
      onClick={onClick}
      className={`buttonComponent ${type}`}
      type={btnType}
    >
      {showUpArrow && !loading && <img src={uploadArrow} alt="plus" />}
      {showImage && !loading && <img src={plusImage} alt="plus" />}
      {showPurplePlus && !loading && <img src={purplePlus} alt="plus" />}
      {loading ? (
        <div className="spinner"></div>
      ) : (
        title || children
      )}
    </button>
  );
};

export default Button;
